import Image from 'next/image';
import React from 'react';
import { NextImageStyleCover } from '../../BabyNameFinder/styled';

function ImageCoverComponent(props) {
  const { imageRatioMobile, imageRatioDesktop, mobileImage, desktopImage } =
    props;

  if (!mobileImage && !desktopImage) return null;

  return (
    <NextImageStyleCover
      imageRatioMobile={imageRatioMobile}
      imageRatioDesktop={imageRatioDesktop}
    >
      <Image
        className="mobile_image"
        src={mobileImage || desktopImage}
        alt=""
        quality={90}
        fill
        sizes="70vw"
      />
      <Image
        className="desktop_image"
        src={desktopImage || mobileImage}
        alt=""
        quality={90}
        fill
        sizes="70vw"
      />
    </NextImageStyleCover>
  );
}

export default ImageCoverComponent;
